import logoDefault from "../assets/images/LP-arabe/logo-escola-arabe.svg"

export const LogoImage = {
  light: logoDefault,
};

export const NavLinks = [
  {
    name: "Início",
    url: "/",
  },
  {
    name: "Sobre Nós",
    url: "/sobre-nos",
  },
  {
    name: "Estrutura",
    url: "/sobre-nos#estrutura",
  },
  {
    name: "Cultura",
    url: "/cultura",
  },
  {
    name: "Contato",
    url: "/#fale-conosco",
  },
];

export const NavInnerLinks = [
  {
    name: "Início",
    url: "/",
  },
  {
    name: "Sobre Nós",
    url: "/sobre-nos",
  },
  {
    name: "Estrutura",
    url: "/sobre-nos#estrutura",
  },
  {
    name: "Cultura",
    url: "/cultura",
  },
  {
    name: "Contato",
    url: "/#fale-conosco",
  },
];
